<template>
  <div class="home-page">
    <!-- 顶部栏 -->
    <header>
      <div class="logo-area">
        <div class="brand-mark" aria-hidden="true">
          <i></i><i></i><i></i><i></i><i></i>
        </div>
        <span class="brand-title">{{ SystemName }}</span>
      </div>
      <div class="status-area">
        <!-- <div class="status-item">
          <span class="dot"></span>
          <span>设备在线</span>
        </div> -->
        <div class="status-item">
          <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path d="M12 20h.01M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 14 0M1.5 9.5a15 15 0 0 1 21 0"
                  stroke-linecap="round" />
          </svg>
          <span>网络正常</span>
        </div>
        <div class="status-item">
          <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <span>{{ currentTime }}</span>
        </div>
      </div>
    </header>

    <!-- 主视觉区 -->
    <section class="hero">
      <div class="hero-copy">
        <h1>开启智能<span>投顾服务</span></h1>
        <p class="subtitle">AI驱动风险评估与资产配置，一站式完成智能投顾流程</p>
        <div class="actions-wrapper">
          <button class="launch-btn" :disabled="launchBtnDisabled" type="button" @click="handleStart">
            <span>{{ launchText }}</span>
            <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
        <div class="btn-details">
          <div class="detail-item">
            <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            <span>预计用时 3-5 分钟</span>
          </div>
          <div class="detail-item">
            <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            <span>适用于首次体验与快速评估</span>
          </div>
        </div>
        <div v-if="launchTip" class="launch-tip">{{ launchTip }}</div>
      </div>

      <div class="hero-visual">
        <!-- 城市剪影背景 -->
        <svg class="city-skyline" viewBox="0 0 800 120" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="skylineGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stop-color="var(--blue)" stop-opacity="0.07" />
              <stop offset="100%" stop-color="var(--blue)" stop-opacity="0.0" />
            </linearGradient>
          </defs>
          <path d="M 0 120 L 0 90 L 15 90 L 15 120 L 25 120 L 25 80 L 40 80 L 40 120 L 50 120 L 50 70 L 70 70 L 70 120 L 85 120 L 85 60 L 100 60 L 100 120 L 110 120 L 110 85 L 125 85 L 125 120 L 135 120 L 135 50 L 150 50 L 150 120 L 160 120 L 160 95 L 175 95 L 175 120 L 190 120 L 190 75 L 210 75 L 210 120 L 220 120 L 220 100 L 235 100 L 235 120 L 245 120 L 245 65 L 265 65 L 265 120 L 280 120 L 280 110 L 295 110 L 295 120 L 310 120 L 310 80 L 325 80 L 325 120 L 335 120 L 335 55 L 355 55 L 355 120 L 370 120 L 370 70 L 385 70 L 385 120 L 400 120 L 400 90 L 415 90 L 415 120 Z"
                fill="url(#skylineGrad)" />
        </svg>
        <!-- 3D智能机器人及其周围的悬浮卡片 -->
        <div class="robot-stage-hp">
          <div class="podium" aria-hidden="true">
            <div class="ring ring-outer"></div>
            <div class="ring ring-inner"></div>
            <div class="ring"></div>
          </div>
          <img class="robot-img" src="@/assets/home/ai_3d_robot.png" alt="AI Robot">

          <!-- 悬浮卡片 1：资产趋势 -->
          <div class="float-card card-trend hp-card">
            <h3>资产趋势</h3>
            <svg class="trend-chart" viewBox="0 0 140 45" fill="none">
              <path d="M 0 35 Q 25 38 45 22 T 90 18 T 140 5" stroke="url(#trendGrad-hp)" stroke-width="3"
                    stroke-linecap="round" />
              <path d="M 0 35 Q 25 38 45 22 T 90 18 T 140 5 L 140 45 L 0 45 Z" fill="url(#trendAreaGrad-hp)" />
              <circle cx="140" cy="5" r="2" fill="var(--blue)" />
              <defs>
                <linearGradient id="trendGrad-hp" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stop-color="var(--blue)" />
                  <stop offset="100%" stop-color="var(--purple)" />
                </linearGradient>
                <linearGradient id="trendAreaGrad-hp" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="rgba(37, 99, 235, 0.1)" />
                  <stop offset="100%" stop-color="rgba(37, 99, 235, 0)" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <!-- 悬浮卡片 2：资产配置建议 -->
          <div class="float-card card-allocation hp-card">
            <h3>资产配置建议</h3>
            <div class="donut-wrapper">
              <div class="donut-chart">
                <svg width="38" height="38" viewBox="0 0 40 40">
                  <circle cx="20" cy="20" r="16" fill="none" stroke="#f1f5f9" stroke-width="6" />
                  <circle cx="20" cy="20" r="16" fill="none" stroke="var(--blue)" stroke-width="6"
                          stroke-dasharray="55.3 100.5" stroke-dashoffset="0" transform="rotate(-90 20 20)" />
                  <circle cx="20" cy="20" r="16" fill="none" stroke="var(--purple)" stroke-width="6"
                          stroke-dasharray="30.15 100.5" stroke-dashoffset="-55.3" transform="rotate(-90 20 20)" />
                  <circle cx="20" cy="20" r="16" fill="none" stroke="var(--green)" stroke-width="6"
                          stroke-dasharray="10.05 100.5" stroke-dashoffset="-85.45" transform="rotate(-90 20 20)" />
                  <circle cx="20" cy="20" r="16" fill="none" stroke="var(--orange)" stroke-width="6"
                          stroke-dasharray="5.0 100.5" stroke-dashoffset="-95.5" transform="rotate(-90 20 20)" />
                </svg>
              </div>
              <div class="donut-legend">
                <div class="legend-item"><span class="legend-label"><i
                       class="legend-color color-blue"></i>股票</span><span>55%</span></div>
                <div class="legend-item"><span class="legend-label"><i
                       class="legend-color color-purple"></i>债券</span><span>30%</span></div>
                <div class="legend-item"><span class="legend-label"><i
                       class="legend-color color-green"></i>基金</span><span>10%</span></div>
                <div class="legend-item"><span class="legend-label"><i
                       class="legend-color color-orange"></i>其它</span><span>5%</span></div>
              </div>
            </div>
          </div>

          <!-- 悬浮卡片 3：风险评级 -->
          <div class="float-card card-risk hp-card">
            <h3>风险评级</h3>
            <div class="risk-badge-wrapper">
              <span class="risk-val">C3</span>
              <div class="risk-label">
                <span class="risk-title">稳健型</span>
                <span class="risk-desc">风险适中，追求稳健增值</span>
              </div>
              <svg class="risk-shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 11l2 2 4-4" stroke-linecap="round"
                      stroke-linejoin="round" />
              </svg>
            </div>
          </div>

          <!-- 悬浮卡片 4：组合预期收益 -->
          <div class="float-card card-return hp-card">
            <h3>组合预期收益</h3>
            <div class="bar-chart-wrapper">
              <div class="bar" style="--height: 12px; height: 12px;"></div>
              <div class="bar" style="--height: 20px; height: 20px;"></div>
              <div class="bar" style="--height: 16px; height: 16px;"></div>
              <div class="bar" style="--height: 26px; height: 26px;"></div>
            </div>
            <div class="return-value-wrapper">
              <span class="return-label">预期年化</span>
              <span class="return-val-num">5.2%</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 竖屏卡片区-->
    <section class="sp-section">
      <!-- 3D智能机器人及其周围的悬浮卡片 -->
      <div class="robot-stage-sp">
        <!-- 悬浮卡片 1：资产趋势 -->
        <div class="float-card card-trend sp-card">
          <h3>资产趋势</h3>
          <svg class="trend-chart" viewBox="0 0 140 45" fill="none">
            <path d="M 0 35 Q 25 38 45 22 T 90 18 T 140 5" stroke="url(#trendGrad-sp)" stroke-width="3"
                  stroke-linecap="round" />
            <path d="M 0 35 Q 25 38 45 22 T 90 18 T 140 5 L 140 45 L 0 45 Z" fill="url(#trendAreaGrad-sp)" />
            <circle cx="140" cy="5" r="2" fill="var(--blue)" />
            <defs>
              <linearGradient id="trendGrad-sp" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stop-color="var(--blue)" />
                <stop offset="100%" stop-color="var(--purple)" />
              </linearGradient>
              <linearGradient id="trendAreaGrad-sp" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="rgba(37, 99, 235, 0.1)" />
                <stop offset="100%" stop-color="rgba(37, 99, 235, 0)" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        <!-- 悬浮卡片 2：资产配置建议 -->
        <div class="float-card card-allocation sp-card">
          <h3>资产配置建议</h3>
          <div class="donut-wrapper">
            <div class="donut-chart">
              <svg width="38" height="38" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="16" fill="none" stroke="#f1f5f9" stroke-width="6" />
                <circle cx="20" cy="20" r="16" fill="none" stroke="var(--blue)" stroke-width="6"
                        stroke-dasharray="55.3 100.5" stroke-dashoffset="0" transform="rotate(-90 20 20)" />
                <circle cx="20" cy="20" r="16" fill="none" stroke="var(--purple)" stroke-width="6"
                        stroke-dasharray="30.15 100.5" stroke-dashoffset="-55.3" transform="rotate(-90 20 20)" />
                <circle cx="20" cy="20" r="16" fill="none" stroke="var(--green)" stroke-width="6"
                        stroke-dasharray="10.05 100.5" stroke-dashoffset="-85.45" transform="rotate(-90 20 20)" />
                <circle cx="20" cy="20" r="16" fill="none" stroke="var(--orange)" stroke-width="6"
                        stroke-dasharray="5.0 100.5" stroke-dashoffset="-95.5" transform="rotate(-90 20 20)" />
              </svg>
            </div>
            <div class="donut-legend">
              <div class="legend-item"><span class="legend-label"><i
                     class="legend-color color-blue"></i>股票</span><span>55%</span></div>
              <div class="legend-item"><span class="legend-label"><i
                     class="legend-color color-purple"></i>债券</span><span>30%</span></div>
              <div class="legend-item"><span class="legend-label"><i
                     class="legend-color color-green"></i>基金</span><span>10%</span></div>
              <div class="legend-item"><span class="legend-label"><i
                     class="legend-color color-orange"></i>其它</span><span>5%</span></div>
            </div>
          </div>
        </div>

        <!-- 悬浮卡片 3：风险评级 -->
        <div class="float-card card-risk sp-card">
          <h3>风险评级</h3>
          <div class="risk-badge-wrapper">
            <span class="risk-val">C3</span>
            <div class="risk-label">
              <span class="risk-title">稳健型</span>
              <span class="risk-desc">风险适中，追求稳健增值</span>
            </div>
            <svg class="risk-shield-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 11l2 2 4-4" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
          </div>
        </div>

        <!-- 悬浮卡片 4：组合预期收益 -->
        <div class="float-card card-return sp-card">
          <h3>组合预期收益</h3>
          <div class="bar-chart-wrapper">
            <div class="bar" style="--height: 12px; height: 12px;"></div>
            <div class="bar" style="--height: 20px; height: 20px;"></div>
            <div class="bar" style="--height: 16px; height: 16px;"></div>
            <div class="bar" style="--height: 26px; height: 26px;"></div>
          </div>
          <div class="return-value-wrapper">
            <span class="return-label">预期年化</span>
            <span class="return-val-num">5.2%</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 流程步骤区 -->
    <section class="process-section">
      <div class="section-title">
        <span class="line"></span>
        <span>智能投顾实训流程 (7步完成)</span>
        <span class="line"></span>
      </div>
      <div class="steps-container">
        <div class="step-card">
          <div class="step-number">1</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path
                    d="M8 3H5a2 2 0 0 0-2 2v3m18-3h-3a2 2 0 0 0-2 2v3M3 16v3a2 2 0 0 0 2 2h3m13-5v3a2 2 0 0 1-2 2h-3M10 10c0-1.1.9-2 2-2s2 .9 2 2v4c0 1.1-.9 2-2 2s-2-.9-2-2z" />
            </svg>
          </div>
          <span class="step-title">智能画像</span>
          <span class="step-desc">建立评估基础</span>
        </div>
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">2</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 11l2 2 4-4" />
            </svg>
          </div>
          <span class="step-title">风险评级</span>
          <span class="step-desc">评估风险偏好</span>
        </div>
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">3</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <line x1="4" y1="21" x2="4" y2="14" />
              <line x1="4" y1="10" x2="4" y2="3" />
              <line x1="12" y1="21" x2="12" y2="12" />
              <line x1="12" y1="8" x2="12" y2="3" />
              <line x1="20" y1="21" x2="20" y2="16" />
              <line x1="20" y1="12" x2="20" y2="3" />
              <line x1="1" y1="14" x2="7" y2="14" />
              <line x1="9" y1="8" x2="15" y2="8" />
              <line x1="17" y1="16" x2="23" y2="16" />
            </svg>
          </div>
          <span class="step-title">模型配置</span>
          <span class="step-desc">AI模型匹配组合</span>
        </div>
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">4</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M21.21 15.89A10 10 0 1 1 8 2.83M22 12A10 10 0 0 0 12 2v10z" />
            </svg>
          </div>
          <span class="step-title">组合推荐</span>
          <span class="step-desc">生成投资方案</span>
        </div>
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">5</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M3 3v18h18M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
            </svg>
          </div>
          <span class="step-title">历史回测</span>
          <span class="step-desc">验证策略表现</span>
        </div>
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">6</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <span class="step-title">压力测试</span>
          <span class="step-desc">评估风险承受力</span>
        </div>
        <!-- <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">7</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <span class="step-title">自动评分</span>
          <span class="step-desc">综合评估方案</span>
        </div> -->
        <div class="step-arrow"><svg viewBox="0 0 24 24">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg></div>
        <div class="step-card">
          <div class="step-number">7</div>
          <div class="step-icon">
            <svg viewBox="0 0 24 24">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </div>
          <span class="step-title">报告生成</span>
          <span class="step-desc">输出投顾报告</span>
        </div>
      </div>
    </section>

    <!-- 下方核心特点区 -->
    <section class="bottom-highlights" aria-label="核心功能特点">
      <div class="highlight-card">
        <div class="highlight-icon icon-blue">
          <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <div class="highlight-text">
          <h2 class="highlight-title">识别用户画像</h2>
          <p class="highlight-desc">多维度分析风险偏好，构建专属投资画像。</p>
        </div>
      </div>
      <div class="highlight-card">
        <div class="highlight-icon icon-purple">
          <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
        </div>
        <div class="highlight-text">
          <h2 class="highlight-title">完成KYC问卷</h2>
          <p class="highlight-desc">合规问卷与风险评估，保障投资安全合规。</p>
        </div>
      </div>
      <div class="highlight-card">
        <div class="highlight-icon icon-green">
          <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
          </svg>
        </div>
        <div class="highlight-text">
          <h2 class="highlight-title">智能生成资产配置建议</h2>
          <p class="highlight-desc">基于模型与市场数据，生成个性化组合方案。</p>
        </div>
      </div>
    </section>

    <!-- 页脚提示 -->
    <footer class="footer-warning">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="footer-icon">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM9 11l2 2 4-4" stroke-linecap="round"
              stroke-linejoin="round" />
      </svg>
      <span>@2026 湖南典阅教育科技有限公司 提供技术支持</span>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data () {
    return {
      SystemName: window.SystemName,
      currentTime: '',
      clockTimer: null,
      launchBtnDisabled: false,
      launchText: '立即开始实训',
      launchTip: ''
    }
  },
  mounted () {
    sessionStorage.clear()
    localStorage.clear()
    this.updateClock()
    this.clockTimer = setInterval(this.updateClock, 1000)
  },
  beforeDestroy () {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
  },
  methods: {
    updateClock () {
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      this.currentTime = `${hours}:${minutes}`
    },
    handleStart () {
      this.launchBtnDisabled = true
      this.launchText = '正在启动...'
      this.launchTip = '正在启动"。'

      // // 播放欢迎语音（用户点击手势已满足自动播放策略）
      // const audio = document.createElement('audio')
      // audio.src = '/您好，我是您的AI投顾助理，请正对下方屏幕上的摄像头进行信息识别.mp3'
      // audio.autoplay = true
      // audio.style.display = 'none'
      // document.body.appendChild(audio)

      setTimeout(() => {
        this.$router.push({ name: 'Login' })
      }, 600)
    }
  }
}
</script>

<style scoped>
.home-page {
  --ink: #0d2148;
  --muted: #64748b;
  --blue: #2563eb;
  --blue-glow: rgba(37, 99, 235, 0.15);
  --purple: #7c3aed;
  --purple-glow: rgba(124, 58, 237, 0.15);
  --green: #10b981;
  --orange: #f59e0b;
  --bg-gradient: radial-gradient(circle at 18% 20%, rgba(255, 255, 255, .98) 0 18%, rgba(255, 255, 255, .45) 42%, transparent 62%),
    radial-gradient(circle at 82% 42%, rgba(106, 158, 255, .20), transparent 38%),
    linear-gradient(135deg, #f9fbff 0%, #eef4ff 47%, #d9e7ff 100%);
  --glass-bg: rgba(255, 255, 255, 0.72);
  --glass-border: rgba(255, 255, 255, 0.8);
  --shadow: 0 10px 30px rgba(57, 101, 185, 0.06);
  --btn-gradient: linear-gradient(105deg, #2563eb 0%, #4f46e5 50%, #7c3aed 100%);

  width: 100vw;
  height: 100vh;
  overflow: hidden;
  color: var(--ink);
  background: var(--bg-gradient);
  font-family: 'Outfit', 'Noto Sans SC', sans-serif;
  position: relative;
  box-sizing: border-box;
}

/* 背景科技网格感 */
.home-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: .12;
  background-image: linear-gradient(rgba(85, 119, 185, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(85, 119, 185, 0.05) 1px, transparent 1px);
  background-size: 24px 24px;
  z-index: 0;
}

.home-page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3vh 3.5vw;
  max-width: 1280px;
  margin: 0 auto;
}

/* 顶部栏 */
header {
  height: 6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
}

.brand-mark i {
  display: block;
  width: 5px;
  border-radius: 8px;
  background: linear-gradient(180deg, #2563eb, #7c3aed);
  box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);
}

.brand-mark i:nth-child(1) {
  height: 10px;
}

.brand-mark i:nth-child(2) {
  height: 16px;
}

.brand-mark i:nth-child(3) {
  height: 22px;
}

.brand-mark i:nth-child(4) {
  height: 15px;
}

.brand-mark i:nth-child(5) {
  height: 8px;
}

.brand-title {
  font-size: 1.2rem;
  font-weight: 850;
  letter-spacing: 0.5px;
  color: var(--ink);
}

.status-area {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 50px;
}

.status-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--muted);
  background: rgba(255, 255, 255, 0.55);
  padding: 5px 10px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.6);
}

.status-item .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: var(--green);
  box-shadow: 0 0 6px var(--green);
  animation: blink 2s infinite ease-in-out;
}

.status-item svg {
  width: 13px;
  height: 13px;
  stroke: var(--muted);
  fill: none;
}

/* 主视觉区 */
.hero {
  flex: 1;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 40px;
  align-items: center;
  min-height: 0;
  height: 56vh;
}

.hero-copy {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

h1 {
  font-size: 3.4rem;
  font-weight: 900;
  line-height: 1.18;
  letter-spacing: -0.5px;
  color: var(--ink);
  margin: 0;
}

h1 span {
  background: linear-gradient(90deg, #2563eb 0%, #4f46e5 50%, #7c3aed 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: block;
  margin-top: 3px;
}

.subtitle {
  font-size: 1.1rem;
  color: var(--muted);
  margin: 12px 0 28px;
  line-height: 1.45;
}

.actions-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 320px;
}

.launch-btn {
  width: 100%;
  height: 60px;
  background: var(--btn-gradient);
  border: none;
  border-radius: 30px;
  color: white;
  font-size: 1.25rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.launch-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 25px rgba(79, 70, 229, 0.28);
}

.launch-btn:active:not(:disabled) {
  transform: translateY(1px);
}

.launch-btn:disabled {
  opacity: 0.85;
  cursor: not-allowed;
}

.launch-btn svg {
  width: 18px;
  height: 18px;
  stroke: white;
  stroke-width: 2.5;
  fill: none;
  transition: transform 0.3s ease;
}

.launch-btn:hover:not(:disabled) svg {
  transform: translateX(4px);
}

.btn-details {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  color: var(--muted);
  font-weight: 500;
}

.detail-item svg {
  width: 13px;
  height: 13px;
  stroke: var(--muted);
  fill: none;
}

.launch-tip {
  margin-top: 8px;
  font-size: 0.7rem;
  color: var(--muted);
}

/* 3D智能机器人与悬浮卡片区 */
.hero-visual {
  position: relative;
  height: 100%;
  width: 100%;
}

.robot-stage-hp {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 320px;
  height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.podium {
  position: absolute;
  bottom: 30px;
  width: 240px;
  height: 50px;
  perspective: 1000px;
  z-index: 1;
}

.ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1.5px solid rgba(37, 99, 235, 0.2);
  transform: rotateX(70deg);
  box-shadow: 0 0 15px rgba(37, 99, 235, 0.1), inset 0 0 15px rgba(37, 99, 235, 0.1);
  animation: pulseRing 3s infinite ease-in-out;
}

.ring-outer {
  inset: -15px;
  border-color: rgba(124, 58, 237, 0.12);
  animation-delay: 0.5s;
}

.ring-inner {
  inset: 15px;
  border-style: dashed;
  border-color: rgba(37, 99, 235, 0.25);
  animation: rotateRing 15s infinite linear;
}

.robot-img {
  width: 240px;
  height: 240px;
  z-index: 2;
  animation: floatRobot 4s infinite ease-in-out;
  transform-origin: center bottom;
  pointer-events: none;
}

/* 悬浮玻璃卡片 */
.float-card {
  position: absolute;
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 14px;
  padding: 9px 11px;
  box-shadow: var(--shadow);
  z-index: 5;
  animation: floatCard 6s infinite ease-in-out;
  pointer-events: none;
}

.float-card h3 {
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--muted);
  margin-bottom: 4px;
  letter-spacing: 0.5px;
}

.card-trend {
  top: 10px;
  left: -70px;
  width: 150px;
  animation-delay: 0s;
}

.trend-chart {
  width: 100%;
  height: 38px;
}

.card-allocation {
  top: 0px;
  right: -100px;
  width: 180px;
  animation-delay: 1.5s;
}

.donut-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.donut-chart {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
}

.donut-legend {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5px;
  font-size: 0.55rem;
  font-weight: 700;
}

.legend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.legend-label {
  display: flex;
  align-items: center;
  gap: 2px;
}

.legend-color {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}

.color-blue {
  background-color: var(--blue);
}

.color-purple {
  background-color: var(--purple);
}

.color-green {
  background-color: var(--green);
}

.color-orange {
  background-color: var(--orange);
}

.card-risk {
  bottom: 20px;
  left: -75px;
  width: 155px;
  animation-delay: 3s;
}

.risk-badge-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.risk-val {
  font-size: 1.35rem;
  font-weight: 900;
  color: var(--orange);
  font-family: 'Outfit', sans-serif;
}

.risk-label {
  display: flex;
  flex-direction: column;
}

.risk-title {
  font-size: 0.75rem;
  font-weight: 800;
  color: var(--ink);
}

.risk-desc {
  font-size: 0.55rem;
  color: var(--muted);
}

.card-return {
  bottom: 15px;
  right: -65px;
  width: 145px;
  animation-delay: 4.5s;
}

.bar-chart-wrapper {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 28px;
  padding: 0 4px;
  margin-bottom: 4px;
}

.bar {
  width: 8px;
  background: linear-gradient(to top, var(--blue), #60a5fa);
  border-radius: 2px 2px 0 0;
  animation: growBar 1.5s ease-out forwards;
}

.bar:nth-child(2) {
  background: linear-gradient(to top, var(--purple), #a78bfa);
}

.bar:nth-child(3) {
  background: linear-gradient(to top, var(--green), #34d399);
}

.bar:nth-child(4) {
  background: linear-gradient(to top, var(--orange), #fbbf24);
}

.return-value-wrapper {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 3px;
  margin-top: 4px;
}

.return-label {
  font-size: 0.62rem;
  color: var(--muted);
  font-weight: 600;
}

.return-val-num {
  font-size: 0.88rem;
  font-weight: 800;
  color: var(--blue);
}

.risk-shield-icon {
  width: 15px;
  height: 15px;
  color: #f59e0b;
  fill: rgba(245, 158, 11, 0.1);
  margin-left: auto;
  flex-shrink: 0;
}

.sp-section {
  display: none;
}

/* 流程系统步骤区 */
.process-section {
  height: 28vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-shrink: 0;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--muted);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.section-title .line {
  flex: 0 0 50px;
  height: 1px;
  background-color: rgba(77, 111, 191, 0.15);
}

.steps-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 10px 0;
}

.step-card {
  position: relative;
  width: 130px;
  height: 140px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-shadow: 0 4px 15px rgba(57, 101, 185, 0.02);
  z-index: 2;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.step-card:hover {
  transform: translateY(-3px);
  background: white;
  border-color: var(--blue);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.1);
}

.step-number {
  position: absolute;
  top: -11px;
  left: -11px;
  width: 24px;
  height: 24px;
  background: var(--blue);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 800;
  box-shadow: 0 2px 5px rgba(37, 99, 235, 0.25);
}

.step-icon {
  color: var(--blue);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.step-card:hover .step-icon {
  transform: scale(1.08);
}

.step-icon svg {
  width: 36px;
  height: 36px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
}

.step-title {
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--ink);
}

.step-desc {
  font-size: 0.75rem;
  color: var(--muted);
  margin-top: 1px;
  text-align: center;
}

.step-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e1;
  z-index: 2;
}

.step-arrow svg {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  stroke-width: 3;
  fill: none;
}

/* 城市剪影背景 */
.city-skyline {
  position: absolute;
  bottom: 0;
  left: 10%;
  width: 45%;
  height: 75px;
  z-index: 1;
  pointer-events: none;
}

/* 下方核心特点区 - 横屏下隐藏 */
.bottom-highlights {
  display: none;
  height: 15vh;
  gap: 16px;
  justify-content: space-between;
}

.highlight-card {
  flex: 1;
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 12px 18px;
  box-shadow: var(--shadow);
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

.highlight-card:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 15px 40px rgba(57, 101, 185, 0.12);
}

.highlight-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
}

.icon-blue {
  background: #eff6ff;
  color: var(--blue);
}

.icon-purple {
  background: #f5f3ff;
  color: var(--purple);
}

.icon-green {
  background: #ecfdf5;
  color: var(--green);
}

.highlight-icon svg {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  fill: none;
}

.highlight-text {
  flex: 1;
}

.highlight-title {
  font-size: 0.85rem;
  font-weight: 800;
  color: var(--ink);
  margin-bottom: 2px;
}

.highlight-desc {
  font-size: 0.7rem;
  color: var(--muted);
  line-height: 1.35;
}

.footer-warning {
  text-align: center;
  font-size: 0.82rem;
  color: #475569;
  margin-top: 2vh;
  /* background: rgba(37, 99, 235, 0.04); */
  /* border: 1px solid rgba(37, 99, 235, 0.12); */
  padding: 10px 24px;
  border-radius: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  flex-shrink: 0;
}

.footer-warning svg {
  width: 16px;
  height: 16px;
  stroke: var(--blue);
  stroke-width: 2.5;
  fill: none;
  flex-shrink: 0;
}

/* 动画配置 */
@keyframes blink {

  0%,
  100% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }
}

@keyframes pulseRing {

  0%,
  100% {
    transform: rotateX(70deg) scale(0.96);
    opacity: 0.7;
  }

  50% {
    transform: rotateX(70deg) scale(1.04);
    opacity: 1;
  }
}

@keyframes rotateRing {
  to {
    transform: rotateX(70deg) rotate(360deg);
  }
}

@keyframes floatRobot {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

@keyframes floatCard {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-5px);
  }
}

@keyframes growBar {
  from {
    height: 0;
  }

  to {
    height: var(--height);
  }
}

/* =======================================================
   竖屏自适应媒体查询 (兼容平板、手机等)
   ======================================================= */
@media (max-aspect-ratio: 6/5) {
  .home-page {
    padding: 1.5vh 3vw;
    overflow: hidden;
  }

  .status-area {
    margin: 0;
  }

  header {
    height: 5vh;
    padding: 0 1vw;
  }

  .logo-area {
    gap: 6px;
  }

  .sp-section {
    display: block;
  }

  .hp-card {
    display: none;
  }

  .sp-card {
    display: block;
  }

  .brand-mark {
    height: 18px;
  }

  .brand-title {
    font-size: 0.95rem;
  }

  .status-area {
    gap: 6px;
  }

  .status-item {
    padding: 3px 6px;
    font-size: 0.68rem;
    gap: 3px;
  }

  .status-item svg {
    width: 11px;
    height: 11px;
  }

  .hero {
    display: flex;
    flex-direction: column;
    height: 50vh;
    gap: 0;
  }

  .hero-copy {
    flex: 0 0 auto;
    text-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 2.5vh;
    margin-bottom: 2.5vh;
  }

  h1 {
    font-size: 1.8rem;
    line-height: 1.25;
  }

  .subtitle {
    font-size: 0.8rem;
    margin: 8px 0 14px;
    line-height: 1.4;
  }

  .actions-wrapper {
    max-width: 240px;
    height: 48px;
  }

  .launch-btn {
    height: 48px;
    font-size: 1.05rem;
    border-radius: 24px;
  }

  .btn-details {
    margin-top: 10px;
    justify-content: center;
    gap: 12px;
  }

  .detail-item {
    font-size: 0.72rem;
    gap: 4px;
  }

  .launch-tip {
    margin-top: 2px;
  }

  .hero-visual {
    flex: 1;
    width: 100%;
    position: relative;
  }

  /* 竖屏：四张卡牌 2×2 网格排布，尺寸放大 */
  .robot-stage-sp {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
    width: 100%;
    /* max-width: 520px; */
    height: auto;
    min-height: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 14px;
    margin: 0 auto;
  }

  .robot-img {
    width: 270px;
    height: 270px;
  }

  .podium {
    width: 180px;
    height: 36px;
    bottom: 8px;
  }

  .float-card {
    position: static;
    padding: 14px 16px;
    border-radius: 14px;
  }

  .float-card h3 {
    font-size: 0.85rem;
    margin-bottom: 8px;
  }

  .card-trend {
    width: auto;
  }

  .trend-chart {
    height: 42px;
  }

  .card-allocation {
    width: auto;
  }

  .donut-chart {
    width: 46px;
    height: 46px;
    flex: 0 0 46px;
    aspect-ratio: auto;
  }

  .donut-legend {
    font-size: 0.65rem;
    gap: 3px;
  }

  .card-risk {
    width: auto;
  }

  .risk-badge-wrapper {
    gap: 8px;
  }

  .risk-val {
    font-size: 1.55rem;
  }

  .risk-title {
    font-size: 0.85rem;
  }

  .risk-desc {
    font-size: 0.62rem;
  }

  .risk-shield-icon {
    width: 28px;
    height: 28px;
  }

  .card-return {
    width: auto;
  }

  .bar-chart-wrapper {
    height: 32px;
    margin-bottom: 6px;
    min-height: 0;
  }

  .bar {
    width: 9px;
  }

  .return-val-num {
    font-size: 1.05rem;
  }

  .return-label {
    font-size: 0.72rem;
  }

  /* 流程步骤改造成 2x4 紧凑网格布局，完美在单屏幕展示 */
  .process-section {
    height: 34vh;
    justify-content: space-evenly;

  }

  .steps-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 10px;
    padding: 8px;
    border-radius: 16px;
  }

  .step-card {
    width: 100%;
    height: 90px;
    gap: 6px;
    border-radius: 12px;
  }

  .step-number {
    top: -7px;
    left: -7px;
    width: 18px;
    height: 18px;
    font-size: 0.65rem;
  }

  .step-icon svg {
    width: 26px;
    height: 26px;
  }

  .step-title {
    font-size: 0.78rem;
  }

  /* 特点区在竖屏下隐藏 */
  .bottom-highlights {
    display: none;
  }

  .step-desc {
    display: none;
  }

  .step-arrow {
    display: none;
  }

  .city-skyline {
    display: none;
  }

  .footer-warning {
    display: block;
    background: none;
    border: none;
    padding: 0;
    margin-top: 1vh;
    color: var(--muted);
    width: auto;
    font-size: 0.68rem;
  }

  .footer-warning svg {
    display: none;
  }
}

/* =======================================================
   大屏幕竖屏自适应媒体查询 (如 1080x1920 双屏终端下屏幕)
   ======================================================= */
@media (max-aspect-ratio: 6/5) and (min-width: 600px) {
  .home-page {
    padding: 2.5vh 4vw;
    max-width: 1080px;
    margin: 0 auto;
    justify-content: space-between;
  }

  header {
    height: 6vh;
    margin-bottom: 2vh;
    flex: none;
  }

  .brand-mark {
    height: 32px;
    gap: 6px;
  }

  .brand-mark i {
    width: 7px;
    border-radius: 8px;
  }

  .brand-mark i:nth-child(1) {
    height: 14px;
  }

  .brand-mark i:nth-child(2) {
    height: 22px;
  }

  .brand-mark i:nth-child(3) {
    height: 30px;
  }

  .brand-mark i:nth-child(4) {
    height: 20px;
  }

  .brand-mark i:nth-child(5) {
    height: 11px;
  }

  .brand-title {
    font-size: 1.55rem;
    white-space: nowrap;
  }

  .status-item {
    padding: 6px 12px;
    font-size: 0.95rem;
    border-radius: 30px;
    gap: 6px;
    white-space: nowrap;
  }

  .status-item .dot {
    width: 8px;
    height: 8px;
  }

  .status-item svg {
    width: 15px;
    height: 15px;
  }

  /* Hero Section: Two Columns (Left Copy, Right Robot) */
  .hero {
    flex: none;
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 24px;
    align-items: center;
    height: auto;
    margin-bottom: 2vh;
  }

  .hero-copy {
    text-align: left;
    align-items: flex-start;
    padding-top: 0;
    margin-bottom: 0;
  }

  h1 {
    font-size: 2.6rem;
    line-height: 1.2;
  }

  .subtitle {
    font-size: 1.05rem;
    margin: 8px 0 16px;
    line-height: 1.4;
    text-align: left;
  }

  .actions-wrapper {
    max-width: 300px;
    height: 56px;
  }

  .launch-btn {
    height: 56px;
    font-size: 1.3rem;
    border-radius: 28px;
    gap: 8px;
  }
}
</style>
